<script>

import InfoCard from "@/components/ui/InfoCard.vue";

export default {
    components: {InfoCard},

    data() {
        return {
            data: {},
            loading: {
                data: true,
            },
            controller: {
                dashboard: null
            },
        }
    },
    methods: {

        loadDashboardData() {
            this.controller.dashboard = new AbortController();
            axios.get('/dashboard', {
                signal: this.controller.dashboard.signal
            }).then(response => {
                this.data = response.data;
            }).finally(() => {
                this.loading.data = false;
            })
        },
    },
    mounted() {
        this.loadDashboardData();
    },
    beforeUnmount() {
        this.controller.dashboard && this.controller.dashboard.abort();
    }
}
</script>

<template>
    <section class="dashboard">
        <loader :loading="loading.data"></loader>
        <div v-if="!loading.data" class="block">
            <div class="info-cards-container mb-6 mt-6 is-flex is-justify-content-start is-flex-wrap-wrap">
                <InfoCard :data="data.employees_without_completed_training_with_tokens_received"
                          :route="{name: 'employees.index', query: {no_trainings_tokens: 30}}">
                    <template #title>
                        {{ $t('dashboard.admin.no_trainings_tokens') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.no_trainings_tokens_description') }}
                    </template>
                </InfoCard>

                <InfoCard :data="data.inactive_accounts_with_tokens_received"
                          :route="{name: 'employees.index', query: {inactive_with_tokens: 30}}">
                    <template #title>
                        {{ $t('dashboard.admin.inactive_with_tokens') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.inactive_with_tokens_description') }}
                    </template>
                </InfoCard>

                <InfoCard :data="data.employees_without_company"
                          :route="{name: 'employees.index', query: {without_company: 1}}">
                    <template #title>
                        {{ $t('dashboard.admin.employees_without_company') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.employees_without_company_description') }}
                    </template>
                </InfoCard>

                <InfoCard :data="data.pending_withdrawals"
                          :route="{name: 'companies.pending-withdrawals'}">
                    <template #title>
                        {{ $t('dashboard.admin.pending_withdrawals') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.pending_withdrawals_description') }}
                    </template>
                </InfoCard>

                <InfoCard :data="data.trainings">
                    <template #title>
                        {{ $t('dashboard.admin.trainings') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.trainings_description') }}
                    </template>
                </InfoCard>

                <InfoCard :data="data.employees">
                    <template #title>
                        {{ $t('dashboard.admin.employees') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.employees_description') }}
                    </template>
                </InfoCard>

                <InfoCard :data="data.employers">
                    <template #title>
                        {{ $t('dashboard.admin.employers') }}
                    </template>
                    <template #subtitle>
                        {{ $t('dashboard.admin.employers_description') }}
                    </template>
                </InfoCard>
            </div>
        </div>
    </section>
</template>
